import React, { useState } from "react";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import { Tabs } from "antd";
import Deposits from "../../components/admin/transactions/Deposits";
import PayInAdvance from "../../components/admin/transactions/PayInAdvance";
import GenerateInvoice from "../../components/admin/transactions/GenerateInvoice";
import ProcessManually from "../../components/admin/transactions/ProcessManually";

const Transactions = () => {
  const [transactionsActiveTab, setTransactionsActiveTab] = useState("deposit");
  const [generateInvoice, setGenerateInvoice] = useState(false);

  const tabItems = [
    {
      key: "deposit",
      label: "Deposit",
      children: <Deposits transactionsActiveTab={transactionsActiveTab} />,
    },
    {
      key: "payInAdvance",
      label: "Pay in advance",
      children: <PayInAdvance transactionsActiveTab={transactionsActiveTab} />,
    },
    {
      key: "all",
      label: "All",
      children: (
        <ProcessManually transactionsActiveTab={transactionsActiveTab} />
      ),
    },
  ];

  const onTabChange = (key) => {
    setTransactionsActiveTab(key);
  };

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Service Provider Header */}
        <div className="w-full py-4">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold title text-lg text-[#000000]">
              Transactions & Invoices
            </h2>
            {(transactionsActiveTab === "deposit" ||
              transactionsActiveTab === "payInAdvance") && (
              <button
                onClick={() => setGenerateInvoice(true)}
                className="text-xs px-3 rounded-2xl py-[9px] bg-[#61373f] text-white font-normal"
              >
                Generate Reports
              </button>
            )}
          </div>
        </div>

        {/* Service Provider */}
        <div className="w-full main-scroll min-h-[calc(100vh-170px)] h-[352px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl pt-5 bg-white">
          <div className="w-full space-tab">
            <Tabs
              defaultActiveKey="deposit"
              activeKey={transactionsActiveTab}
              items={tabItems}
              onChange={onTabChange}
            />
          </div>
        </div>
      </div>

      <GenerateInvoice
        generateInvoice={generateInvoice}
        setGenerateInvoice={setGenerateInvoice}
        transactionsActiveTab={transactionsActiveTab}
      />
    </div>
  );
};

export default withDashboardLayout(Transactions);
